import bind from 'apmui/decorators/bind';
import * as React from 'react';
import Form from 'apmui/components/form/View';
import { IOktaMfaModel, IOktaMfaEvent, FIELD_TOTP, Action } from './Model';
import { IFormField, INPUT } from 'apmui/components/form/Model';

interface IOktaVerifyProps {
    okta: IOktaMfaModel;
    onClick: (data: IOktaMfaEvent) => void;
    transparent?: boolean;
}

/*
 * This component is used to display form to enter
 * otp during verification and enrollment process.
 */
class OktaVerify extends React.Component<IOktaVerifyProps> {
    @bind
    handleClick() {
        const data: IOktaMfaEvent = {
            action: Action.VERIFY,
            name: FIELD_TOTP,
        };
        this.props.onClick(data);
    }
    render() {
        const { strings, state, form } = this.props.okta.oktaMfa;
        if (form.fields.length == 0) {
            const totpField: IFormField = {
                name: FIELD_TOTP,
                type: INPUT.TEXT,
                caption: strings.enterCode,
                disabled: false,
                value: undefined,
            };
            form.fields.push(totpField);
        }
        const otpBtnClass = this.props.transparent
            ? 'apmui-button apmui-button-long'
            : 'apmui-button apmui-button-submit apmui-button-long';
        const totpSubmit = (
            <span className="button-container">
                <input
                    type="submit"
                    className={otpBtnClass}
                    id="okta_totp.submit"
                    value={strings.verify}
                    onClick={this.handleClick}
                />
            </span>
        );
        const otpVerify = state.isOtp && (
            <div>
                <Form {...form} />
                <p>{totpSubmit}</p>
            </div>
        );
        return <div>{otpVerify}</div>;
    }
}

export default OktaVerify;
